import { render } from "./VigenciasMoraRegistro.vue?vue&type=template&id=cead50fc"
import script from "./VigenciasMoraRegistro.vue?vue&type=script&lang=js"
export * from "./VigenciasMoraRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__